import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/zustand";

const HOME_PRODUCTS = ["corporate", "physio_user"];

const RequireHomeAccess = () => {
  const { isAuthenticated, currentProduct } = useAuthStore();

  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  if (currentProduct === "physio_therapist") {
    return <Navigate to="/physio-dashboard" replace />;
  }

  if (!HOME_PRODUCTS.includes(currentProduct)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequireHomeAccess;
